import { createContext } from "react";
import { HomePageContextInterface } from "@/types/contextTypes";

export const HomePageContext = createContext<
  HomePageContextInterface | undefined
>(undefined);
